export default [{
  path: '/config-profile-activities',
  name: 'config-profile-activities',
  component: () => import('./ConfigProfileActivities'),
  meta: {
    resource: 'dashboard',
    actions: ['read']
  }
}]
